import React from 'react';
import AddItemIcon from '@mui/icons-material/AddCircle';
import { Button } from '@mui/material';

import { hasProjectHierarchyFeatureFlag } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../../monitor';
import { createBuildingAndSaveProject } from '../../../../../store/actions/layout/hierarchyActions';
import { isInsertingAnyObject } from '../../../../../store/selectors/insertionObjectSelectors';
import { useAppDispatch, useAppSelector } from '../../../../hooks';

export function AddBuildingButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const clientContext = useAppSelector((state) => state.application.openContext);
  const isInsertingObject = useAppSelector(isInsertingAnyObject);
  const projectHierarchyModificationEnabled = useAppSelector(hasProjectHierarchyFeatureFlag);

  if (clientContext?.type !== 'project' || !projectHierarchyModificationEnabled) return null;

  return (
    <Button
      variant="outlined"
      startIcon={<AddItemIcon />}
      disabled={isInsertingObject}
      onClick={async () => {
        monitor.recordInteraction('Add Building button clicked');
        await dispatch(createBuildingAndSaveProject({ selectAfterCreation: true }));
      }}
    >
      Add Building
    </Button>
  );
}
